/* FIVE AM · Evaluaciones. 20/09/2026.
 *
 * Tres cosas sobre el bloque de reseñas de la ficha, que lo pinta Judge.me y es una
 * aplicación de Vue: no pasa por Liquid y no se puede tocar desde la plantilla.
 *
 *   1. El titular lo pone Judge.me —«Reseñas de Clientes»— y el bloque de aplicación
 *      solo expone cuatro ajustes (review_data, max_width, show_shop_reviews y
 *      empty_state), ninguno de texto. Se renombra aquí a «Evaluaciones», y hay que
 *      volver a aplicarlo porque Vue repinta al filtrar, al paginar y al abrir el
 *      formulario.
 *   2. Antes de escribir se pide el correo. Si el visitante tiene la sesión iniciada
 *      no se le pregunta nada: ya lo sabemos, viene en window.FA_EVAL desde
 *      snippets/stylesheets.liquid.
 *   3. Ese correo se copia al formulario de Judge.me, que es quien lo cruza contra los
 *      pedidos y decide la insignia de comprador verificado.
 *
 * LO QUE ESTO NO HACE, y conviene tenerlo claro: pedir el correo es un filtro, no una
 * prueba de compra. Cualquiera puede escribir uno. La comprobación de verdad es el
 * ajuste de Judge.me «solo compradores verificados», que se activa en el panel de la
 * aplicación y no se puede tocar por API porque pide OAuth.
 *
 * Los textos se escriben aquí y no en locales/es.json porque el widget no es del tema
 * y no lee las traducciones de Horizon.
 */
(function () {
  'use strict';

  var TITULO = 'Evaluaciones';
  var BOTON = 'Escribir una evaluación';
  var CLAVE = 'fa-eval-correo';
  var SEL_BOTON = '.jm-action-buttons__button';
  var SEL_RAIZ = '#judgeme_product_reviews';

  var correoCliente = (window.FA_EVAL && window.FA_EVAL.correo) || '';
  var dlg = null;
  var campo = null;
  var aviso = null;
  var pendiente = null;

  function raiz() {
    return document.querySelector(SEL_RAIZ);
  }

  /* sessionStorage revienta en navegación privada y con las cookies bloqueadas.
     Si falla, el filtro simplemente vuelve a preguntar: no se rompe nada. */
  function guardado() {
    try { return sessionStorage.getItem(CLAVE) || ''; } catch (e) { return ''; }
  }
  function guardar(v) {
    try { sessionStorage.setItem(CLAVE, v); } catch (e) { /* sin memoria, se pregunta otra vez */ }
  }

  /* Se cambia el nodo de texto y no el innerHTML: el botón de Judge.me lleva dentro su
     propio icono, y un textContent a secas se lo comería. */
  function sustituir(el, re, nuevo) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      if (re.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(re, nuevo);
    }
  }

  /* Solo el titular y el botón. NO se hace un reemplazo general de «reseña» en todo el
     bloque: ahí dentro va el texto que escriben los clientes, y una evaluación que
     diga «he leído otras reseñas» no es nuestra para reescribirla. */
  function renombrar() {
    var r = raiz();
    if (!r) return;

    var t = r.querySelectorAll('[class*="header__title"]');
    for (var i = 0; i < t.length; i++) {
      if (t[i].textContent.trim() !== TITULO) t[i].textContent = TITULO;
    }

    var b = r.querySelectorAll(SEL_BOTON);
    for (var j = 0; j < b.length; j++) {
      sustituir(b[j], /Escribir una reseña/i, BOTON);
    }
  }

  function montarDialogo() {
    if (dlg || !window.HTMLDialogElement) return dlg;

    dlg = document.createElement('dialog');
    dlg.id = 'fa-eval';
    dlg.className = 'fa-eval';
    dlg.setAttribute('aria-labelledby', 'fa-eval-h');
    dlg.innerHTML =
      '<form method="dialog" class="fa-eval__form" novalidate>' +
        '<h2 class="fa-eval__h" id="fa-eval-h">Antes de evaluar</h2>' +
        '<p class="fa-eval__p">Escribe el correo con el que hiciste el pedido. Lo usamos para comprobar la compra y para que tu evaluación salga como verificada.</p>' +
        '<label class="visually-hidden" for="fa-eval-correo">Tu correo</label>' +
        '<input id="fa-eval-correo" type="email" required autocomplete="email" placeholder="Tu correo" spellcheck="false">' +
        '<p class="fa-eval__aviso" id="fa-eval-aviso" hidden>Escribe un correo válido para continuar.</p>' +
        '<div class="fa-eval__acciones">' +
          '<button type="button" class="fa-eval__x" data-fa-eval-cancelar>Cancelar</button>' +
          '<button type="submit" class="fa-eval__ok">Continuar</button>' +
        '</div>' +
      '</form>';
    document.body.appendChild(dlg);

    campo = dlg.querySelector('#fa-eval-correo');
    aviso = dlg.querySelector('#fa-eval-aviso');

    dlg.querySelector('[data-fa-eval-cancelar]').addEventListener('click', function () {
      pendiente = null;
      dlg.close();
    });

    /* El formulario va con novalidate y se valida a mano: así el aviso sale en
       castellano y en su sitio, y no en el globo del navegador. */
    dlg.querySelector('form').addEventListener('submit', function (e) {
      var v = campo.value.trim();
      if (!v || !campo.checkValidity()) {
        e.preventDefault();
        aviso.hidden = false;
        campo.focus();
        return;
      }
      guardar(v);
      var btn = pendiente;
      pendiente = null;
      /* El diálogo se cierra solo, por el method="dialog". El formulario de Judge.me
         se reabre en el cuadro siguiente, ya con la marca puesta en el botón. */
      setTimeout(function () {
        if (!btn || !btn.isConnected) return;
        btn.dataset.faEval = 'ok';
        btn.click();
        prefijar(v);
      }, 0);
    });

    return dlg;
  }

  /* Judge.me monta su formulario después del clic, y lo monta FUERA de
     #judgeme_product_reviews: comprobado en el DOM el 20/09/2026, la casilla sale como
     input[name="reviewer_email"] colgando del body, no del widget. Por eso se busca en
     todo el documento y no dentro de la raíz, que fue el primer intento y no encontraba
     nada. Se busca durante 8 s y se deja estar: si no aparece, el cliente la escribe. */
  function prefijar(correo) {
    var intentos = 0;
    var t = setInterval(function () {
      var r = raiz();
      var c = document.querySelector('input[name="reviewer_email"]') ||
              (r && r.querySelector('input[type="email"]'));
      if (c) {
        if (!c.value) {
          /* Vue escucha 'input' sobre el setter nativo: asignar .value a secas no le
             llega y el campo se vacía en el primer repintado. */
          var set = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
          set.call(c, correo);
          c.dispatchEvent(new Event('input', { bubbles: true }));
          c.dispatchEvent(new Event('change', { bubbles: true }));
        }
        clearInterval(t);
      }
      if (++intentos > 40) clearInterval(t);
    }, 200);
  }

  /* En fase de captura, para llegar antes que el manejador de Judge.me. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest(SEL_BOTON) : null;
    if (!btn || !btn.closest(SEL_RAIZ)) return;
    if (btn.dataset.faEval === 'ok') return;

    var correo = correoCliente || guardado();
    if (correo) {
      btn.dataset.faEval = 'ok';
      prefijar(correo);
      return;
    }

    if (!montarDialogo()) return;   /* navegador sin <dialog>: se deja pasar el clic */

    e.preventDefault();
    e.stopPropagation();
    pendiente = btn;
    aviso.hidden = true;
    dlg.showModal();
    campo.focus();
  }, true);

  /* El observador se desengancha mientras escribimos nosotros, para no dispararse con
     nuestro propio cambio, y se agrupa con una espera corta para no correr una vez por
     cada nodo que monta Vue.
     La espera es setTimeout y NO requestAnimationFrame: rAF no dispara mientras la
     pestaña no pinta —en segundo plano, o con la ventana tapada— y el widget de
     Judge.me monta justo ahí, al entrar en pantalla. Comprobado el 20/09/2026 en la
     vista previa: con rAF el titular se quedaba en «Reseñas de Clientes». */
  var obs = new MutationObserver(programar);
  var encolado = false;

  function mirar() {
    obs.observe(document.body, { childList: true, subtree: true });
  }
  function programar() {
    if (encolado) return;
    encolado = true;
    setTimeout(function () {
      encolado = false;
      obs.disconnect();
      renombrar();
      mirar();
    }, 50);
  }

  renombrar();
  mirar();
})();
